import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

@Component({
	selector: 'app-user-score',
	templateUrl: './user-score.component.html',
	styleUrl: './user-score.component.scss'
})
export class UserScoreComponent implements OnInit, AfterViewInit {
	breadcrumbList: any[] = [];
	uId: any = null;
	pagetitle = "Report";
	pageLoading1: boolean = false;
	appt: any = null;
	scoreList: any[] = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["Id"];
			this.getDetails();
		});
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getScorelist(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.appt = data;
				this.breadcrumbList = [
					{ path: this.apiService.getHomeURL(), name: "Home" },
					{ path: "/app/userscore/" + this.uId, name: this.pagetitle }
				]
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	formatDate(dateStr: string) {
		try {
			if (dateStr) {
				return moment(dateStr, "YYYY-MM-DD").format("DD-MM-YYYY");
			} else {
				return dateStr;
			}
		} catch (error) {
			return dateStr;
		}
	}
}
